import { baseUrls } from './base-urls'

export const environment = {
  production: false,
  baseUrl: `https://gateway.web-dev.eloaded.eu`,
  appDashboardUrl: `https://dashboard-dev.eloaded.eu`,
  ...baseUrls
}
